import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import AddOrEditContactPage from 'components/AddOrEditContactPage'
import classNames from 'classnames'
import { toggleContactViewPanel } from 'actions/inbox'

const styles = theme => ({
  contactMobileView: {
    height: '100%',
    flex: '0 2 33.33%',
    minWidth: 325,
    position: 'relative',
  },
  notVisible: {
    // visibility: 'hidden',
    // minWidth: 0,
    // flex: '0',
    display: 'none',
  },
  // view: {
  //   transition: 'all 0.3s',
  // },
  closeView: {
    position: 'absolute',
    right: 3,
    top: 3,
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
})

export default connect(
  state => ({
    contactID: state.inbox.conversationSelected,
    contactViewPanelVisible: state.inbox.contactViewPanelVisible,
  }),
  dispatch => bindActionCreators({ toggleContactViewPanel }, dispatch),
)(
  withStyles(styles)(
    ({
      classes,
      contactID,
      location,
      contactViewPanelVisible,
      toggleContactViewPanel,
    }) => (
      <div
        className={classNames(
          classes.view,
          contactViewPanelVisible
            ? classes.contactMobileView
            : classes.notVisible,
        )}
        style={{ backgroundColor: '#fff' }}
      >
        <AddOrEditContactPage
          mobile
          inbox
          contactID={contactID}
          location={location}
        />
        <Cancel
          onClick={() => toggleContactViewPanel(false)}
          className={classes.closeView}
        />
      </div>
    ),
  ),
)
